import { TIChartPointModel } from "../data-point/ti-chart-point.model";

export class TIComparisonHistoryDataModel {
    public symbol = '';
    public points: Array<TIChartPointModel> = [];
    
    constructor(data?: any) {
        if (data) {
            this.symbol = data.symbol;
            
            if (data.points?.length) {
                for(let i = 0; i < data.points.length; i++) {
                    this.points.push(new TIChartPointModel(data.points[i]));
                }
            }
        }
    }
}